export enum PosWaypointType {
  DRAG = 'DRAG',
  GENERIC_STEPBY = 'GENERIC_STEPBY',
  START = 'START',
  LOAD = 'LOAD',
  UNLOAD = 'UNLOAD',
  TRAILER_CONNECTED = 'TRAILER_CONNECTED',
  TRAILER_DISCONNECTED = 'TRAILER_DISCONNECTED',
  DIESEL = 'DIESEL',
  TOLL = 'TOLL',
  DOCUMENTS = 'DOCUMENTS',
  CMR_DELIVERY = 'CMR_DELIVERY',
  MAINTAINANCE = 'MAINTENANCE',
}

export enum PosVehicleState {
  IN_MOVEMENT_WITH_TRIP = 'IN_MOVEMENT_WITH_TRIP',
  STUCK_WITH_TRIP = 'STUCK_WITH_TRIP',
  IN_WARNING_WITH_TRIP = 'IN_WARNING_WITH_TRIP',
  IN_ERROR_WITH_TRIP = 'IN_ERROR_WITH_TRIP',
  NO_TRIP_ASSIGNED = 'NO_TRIP_ASSIGNED',
  NOT_RECOGNISED = 'NOT_RECOGNISED',
}

export enum PosRouteStatus {
  INITIALIZED = 'INITIALIZED',
  NOT_ROUTABLE = 'NOT_ROUTABLE',
  READY = 'READY',
  SENT_PLANNING = 'SENT_PLANNING',
  PLANNED = 'PLANNED',
  CALCULATION_ERROR = 'CALCULATION_ERROR',
  CHILD_TRIP = 'CHILD_TRIP',
}

export enum PosSourceType {
  EVENTS = 'EVENTS',
  WEB = 'WEB',
}

export enum ADDRESS_TYPE {
  LOADING = 'LOADING',
  UNLOADING = 'UNLOADING'
}

export interface PosWaypointConfigPerType {
  [postype: string]: PosWaypointConfig;
}

// Potentially here we could have colors or icons as well
export interface PosWaypointConfig {
  includeForPaidDistanceCalculation: boolean; // This has to be included in the calculation of the distance to send to SGA
  includeInRealtimeView: boolean; // Check if this item needs to be shown in the realtime view
  includeInPlanningView: boolean; // If this can be shown in the planning view
  includeInPlanningUserSelection: boolean; // If this can be selected in planning route creation
  includeInPlanningSortable: boolean; // If this should be sortable in the planning
}

export interface PosWaypoint {
  id?: string;
  source: PosSourceType;
  geometry: {
    coordinates: number[],
  }
  type: PosWaypointType;
  transitRadius?: number;
  label?: string;
  icon?: string;
  datetime?: Date;
  config?: PosWaypointConfig;
  isReached?: boolean;
  data?: {}; // Arbitrary data associated
}

export interface PosCountryDetails {
  distance: number;
  trafficTime: number;
  travelTime: number;
  text: string;
  country: string;
}

export interface PosRoute {
  geometry: {
    type: 'Multypoint',
    coordinates: number[][],
  }
  label?: string; // optional name probably not needed
  costs?: {
    toll_costs: number;
    vehicle_costs: number;
    driver_costs: number;
    total_costs: number;
  },
  distance: number;
  trafficTime: number;
  travelTime: number;
  messages?: string[];
  flags?: string[];
  countries?: PosCountryDetails[];
  approximation?: number;
  distancePaid?: number;
  debugId?: number;
}
export interface PosRouteResponse {
  data: PosRoute[];
  debug?: PosDebug[];
}

export interface PosDebug {
  id?: number;
  call: string;
  returnedOne: boolean;
}

export interface PosRoutes {
  id_trip: string;
  parent_trip?: string;
  id_device?: string;
  user: string;
  status: PosRouteStatus;
  trip_status: string;
  created_at?: Date;
  updated_at?: Date;
  waypoints?: PosWaypoint[];
  waypoints_empty?: PosWaypoint[];

  expected_route?: PosRoute;
  actual_route?: PosRoute;
  automatic_route?: PosRoute;

  expected_empty_route?: PosRoute;
  actual_empty_route?: PosRoute;
  automatic_empty_route?: PosRoute;
  inRoute: boolean;
  distanceLeft?: number;
  isDone?: boolean;
  active: boolean;
  trailer_plate: string;
  truck_plate: string;
  loading_date?: string;
}

export interface PosGeocode {
  Label: string;
  HouseNumber?: string;
  Street?: string;
  PostalCode?: string;
  City?: string;
  Province?: string;
  Region?: string;
  Country?: string;
  Latitude: number;
  Longitude: number;
  Matched: boolean;
  Code?: number;
  Company?: string;
  Relevance: number;
  Shape?: any;
}


export enum FUEL_TYPE {
  ELECTRIC = "ELECTRIC",
  DIESEL = "DIESEL",
  CNG = "CNG",
  PETROL = "PETROL",
  LNG = "LNG",
  LPG = "LPG"
}

export enum VEHICLE_TYPE {
  T = "TRACTOR",
  M = "TRUCK",
  R = "TRAILER",
  S = "SEMITRAILER",
  V = "OTHER"
}


export enum EMISSION_TYPE {
  EMISSION_TYPE_0 = "0",
  EMISSION_TYPE_1 = "1",
  EMISSION_TYPE_2 = "2",
  EMISSION_TYPE_3 = "3",
  EMISSION_TYPE_4 = "4",
  EMISSION_TYPE_5 = "5",
  EMISSION_TYPE_5E = "5EEV",
  EMISSION_TYPE_6 = "6",
  EMISSION_TYPE_6B = "6B",
  EMISSION_TYPE_6C = "6C",
  EMISSION_TYPE_6D = "6D"
}

export interface PosVehicleHistory {
  id: string;
  device_type?: GEO_TYPE;
  from_date?: Date;
  to_date?: Date;
}

export interface PosVehicleHistoryRoute {
  path: string[];
  waypoints: {
    type: string;
    id_device: string;
    source: string;
    geometry: {
      type: string;
      coordinates: number[];
    };
    properties: {
      dateTime: string;
      speed: number;
      km: number;
      fuelPercentage: number;
      connected: number;
      weight: number;
      batteryLevel: number;
    }
  }[]
}

export interface PosVehicle {
  description: string;
  plate: string;
  active: boolean;
  isGruber: boolean;
  external_key: string;

  type: VEHICLE_TYPE;
  subtype: {
    subtype_id: string;
    subtype_description: string;
  },

  ILU?: string;
  axles_number: number;
  fuel_type?: FUEL_TYPE;
  tank_volume?: number;
  emission_type?: EMISSION_TYPE;

  combined_vehicles: PosVehicleHistory[];
  registrations: PosVehicleHistory[];
  devices: PosVehicleHistory[];
  drivers: PosVehicleHistory[];
  dispatcher: PosVehicleDispatcher;
  created_at: Date;
  updated_at: Date;
}

export interface PosVehiclesWithBestDevice extends PosVehicle {
  bestDevice?: string;
}

export enum GEO_TYPE {
  FLOTTAWEB = "FLOTTAWEB",
  TRANSICS = "TRANSICS",
  GRUBER_APP = "GRUBER_APP"
}
export interface PosVehicleDispatcher {
  id_dispatcher: string;
  name: string;
  email: string;
  phone: string;
}
export interface PosRecentPosition {
  dateTime: Date;
  position: {
    coordinates: number[];
  }
}

export interface PosRealtime {
  id_device: string;
  source: GEO_TYPE;
  externalCode: string;
  plate?: string;
  dateTime: Date;
  position: {
    coordinates: number[];
  };

  mostRecentPositions?: PosRecentPosition[];
  properties: {
    speed: number;
    km: number;
    fuelPercentage: number;
    weight?: number;
    connected: boolean;
    batteryLevel?: number;
  };
  address?: string;
  isMoving: boolean;
}

export interface PosVehiclePosition {
  vehicles: PosVehicle[] | PosVehiclesWithBestDevice[];
  realtime?: PosRealtime;
  status: PosVehicleState;
  route?: PosRoutes;
}

export enum ADDRESS_MODE {
  DEFAULT = 'DEFAULT',
  GEO_COORDINATE = 'GEO_COORDINATE',
  MANUAL_SET_BY_MARKER = 'MANUAL_SET_BY_MARKER',
  SET_INCOMPLETE = 'SET_INCOMPLETE'
}

export interface PosNewAddress {
  name: string;
  label: string;
  address: string;
  city: string;
  zip: string;
  area: string;
  country: string;
  position: PosAddressPosition;
}

export interface PosAddressRequestModel {
  addressType: string;
  addressCode: string;
  orderNumber: string;
  originalAddressName: string;
  originalAddress: string;
  newAddress: PosNewAddress;
  checkDistance: boolean;
  addressMode: ADDRESS_MODE;
}

export interface PosAddressResponseModel {
  isAddressValid: boolean;
  isAddressInSpecifiedDistance: boolean;
  distanceBetweenTwoAddress: number;
  maxAllowedDistance: number;
  validationMessage: string;
}

export interface PosAddressComponent {
  type: string;
  code: number;
  name: string;
  address?: string;
  zip?: string;
  city?: string;
  area?: string;
  country?: string;
  position?: PosAddressPosition
}

export interface PosAddressPosition {
  latitude: number;
  longitude: number;
}


export interface PosSkippedAddressRequestModel extends PosSkippedAddress {
  id_order: string;
}

export interface PosSkippedAddressModel extends PosSkippedAddress {
  company: number;
  branch: string;
  year: number;
  number: number;
}

interface PosSkippedAddress {
  activityDate: Date;
  note: string;
  address: PosAddressComponent;
  email_id: string;
  userName?: string;
  creation_date: Date;
  updated_date: Date;
}

export interface PosAddressValidationQueryParams {
  id_order: string;
  custName: string;
  adrType: string;
  adrCode: string;
  adrName: string;
  adrAddress: string;
  adrZIP: string;
  adrCity: string;
  adrArea: string;
  adrCountry: string;
  adrLatitude: string;
  adrLongitude: string;
  adrActivityDate: string;
  fullMode: string;
}

export enum POS_FILTER_TYPE {
  SELECT = 'SELECT',
  TEXT = 'TEXT',
}

export enum POS_FILTER_KEYS {
  PLATE = 'plate',
  DISPATCHER = 'dispatcher',
  HANDLER = 'handler',
  VEHICLE_TYPE = 'vehicleType',
  CUSTOMER_CARE = 'customerCare',
  DRIVER = 'driver',
  DISPO = 'idTrip',
  CLIENT_ORDER = 'clientOrder',
}

export interface PosFilter {
  key: POS_FILTER_KEYS;
  type: POS_FILTER_TYPE;
  column?: string;
  enabled: boolean;
  items?: {
    label: string;
    value: string;
  }[];
  selected?: string[] | string;
}

export interface PosDriver {
  id_driver: string;
  active: boolean;
  name: string;
}


export enum POS_CACHE_GEOCODE_SOURCE {
  HERE_MAPS = 'HERE',
  GOOGLE_MAPS = 'GOOGLE',
}

export interface PosReverseGeoCache {
  position: {
    type?: string;
    coordinates: number[];
  };
  source: POS_CACHE_GEOCODE_SOURCE;
  posGeocode: PosGeocode;
  createdAt?: string;
}
